<template>
  <!-- <div
    class="g-grid-container"
    :style="{
      left: rowLabelWidth,
      width: `${100-(this.rowLabelWidth).replace('%','')}%`
    }"
  > -->
  <div
    class="g-grid-container"
    id="grid-container"
    :style="gridStyle"
  >
    <div
      v-for="(hour,index) in allHours"
      :key="index"
      :class="{
        'g-grid-line': true,
        'g-grid-line-highlighted': highlightedHours.includes(hour)
      }"
    />
  </div>
</template>

<script>
import moment from 'moment'

export default {

  name: "GGanttGrid",

  props: {
    chartStart: {type: String},
    chartEnd: {type: String},
    rowLabelWidth: String,
    highlightedHours: {type: Array, default: () => []}
  },

  inject: ['ganttChartProps'],

  computed: {
    allHours(){
      let end = 1
      let res = []

      if(this.ganttChartProps.scaleDays == 1){
        end = Math.floor(Math.abs(moment(this.chartStart).diff(moment(this.chartEnd), 'h')) / 2);
      }else{
        end = (Number(this.gridStyle.width.replace('px', ''))/this.ganttChartProps.scaleSize) * this.ganttChartProps.scaleDays
      }

      for(let i=0; i <= end; i+=1) {
        res.push(i)
      }
      return res
    },
    gridStyle(){
      return {
        left: this.rowLabelWidth,
        width: `${Number(this.$parent.style.width.replace('px', '')) - this.ganttChartProps.rowLabelWidth}px`
      }

    },

  }

}
</script>

<style scoped>
  .g-grid-container{
    position: absolute;
    top: 0;
    width: 1800px;
    height: calc(100% - 23px);
    display: flex;
    justify-content: space-between;
  }

  .g-grid-line{
    width: 1px;
    height: 100%;
    position: relative;
    right: 1px;
    border-right: 1px dashed #eaeaea;
  }

  .g-grid-line-highlighted{
    background: #90CAF9;
    box-shadow: 0px 0px 0px 1px #90CAF9;
  }
</style>
